// 遊戲配置常量
export const GAME_CONFIG = {
  // 遊戲類型
  GAME_TYPES: {
    DECOMPOSITION: "decomposition",
    PLACE_VALUE: "placeValue",
    MULTIPLES: "multiples",
  },

  // 遊戲名稱
  GAME_NAMES: {
    decomposition: "數字分解遊戲",
    placeValue: "算柱十進位遊戲",
    multiples: "倍數規律遊戲",
  },

  // 遊戲描述
  GAME_DESCRIPTIONS: {
    decomposition: "學習20以內的數字加減法分解",
    placeValue: "用算柱理解十進位的概念",
    multiples: "發現2、5、10倍數的規律",
  },

  // 遊戲圖標
  GAME_ICONS: {
    decomposition: "🧮",
    placeValue: "📊",
    multiples: "🔢",
  },
};

// 等級配置
export const LEVEL_CONFIG = {
  // 升級所需正確題數
  QUESTIONS_PER_LEVEL: 5,

  // 分解遊戲等級範圍
  DECOMPOSITION_RANGES: {
    1: { max: 10, label: "入門" },
    2: { max: 10, label: "入門" },
    3: { max: 10, label: "入門" },
    4: { max: 15, label: "進階" },
    5: { max: 15, label: "進階" },
    6: { max: 15, label: "進階" },
    7: { max: 20, label: "挑戰" },
    8: { max: 20, label: "挑戰" },
    9: { max: 20, label: "挑戰" },
    10: { max: 20, label: "大師" },
  },

  // 算柱遊戲等級範圍
  PLACE_VALUE_RANGES: {
    1: { max: 30, label: "入門" },
    2: { max: 30, label: "入門" },
    3: { max: 50, label: "基礎" },
    4: { max: 50, label: "基礎" },
    5: { max: 50, label: "基礎" },
    6: { max: 80, label: "進階" },
    7: { max: 80, label: "進階" },
    8: { max: 80, label: "進階" },
    9: { max: 99, label: "挑戰" },
    10: { max: 99, label: "大師" },
  },

  // 倍數遊戲等級配置
  MULTIPLES_CONFIG: {
    1: { length: 5, label: "入門" },
    2: { length: 5, label: "入門" },
    3: { length: 6, label: "基礎" },
    4: { length: 6, label: "基礎" },
    5: { length: 6, label: "進階" },
    6: { length: 7, label: "進階" },
    7: { length: 7, label: "挑戰" },
    8: { length: 8, label: "挑戰" },
    9: { length: 8, label: "挑戰" },
    10: { length: 8, label: "大師" },
  },
};

// 積分配置
export const SCORE_CONFIG = {
  CORRECT_ANSWER: 10, // 答對一題
  STREAK_BONUS: 5, // 連續答對額外獎勵
  HINT_PENALTY: 3, // 使用提示扣分
  LEVEL_UP_BONUS: 20, // 升級獎勵
};

// 星星配置
export const STAR_CONFIG = {
  CORRECT_ANSWER: 1, // 答對一題
  PERFECT_ANSWER: 2, // 完美答題（無提示）
  LEVEL_UP_BONUS: 3, // 升級獎勵
};

// 提示配置
export const HINT_CONFIG = {
  MAX_HINTS_PER_QUESTION: 3,
  HINT_COOLDOWN: 5000, // 提示冷卻時間（毫秒）
};

// 動畫配置
export const ANIMATION_CONFIG = {
  SUCCESS_DELAY: 1500, // 成功後延遲生成新問題
  WRONG_SHAKE_DURATION: 500,
  LEVEL_UP_DURATION: 2000,
};

// 音效配置（保留擴展用）
export const SOUND_CONFIG = {
  enabled: true,
  volume: 0.5,
};

// 音效工具函數
export const playSound = (frequency, duration, type = "sine") => {
  try {
    if (!SOUND_CONFIG.enabled) return;

    const audioContext = new (window.AudioContext ||
      window.webkitAudioContext)();
    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioContext.destination);

    oscillator.frequency.value = frequency;
    oscillator.type = type;

    gainNode.gain.setValueAtTime(SOUND_CONFIG.volume, audioContext.currentTime);
    gainNode.gain.exponentialRampToValueAtTime(
      0.01,
      audioContext.currentTime + duration
    );

    oscillator.start(audioContext.currentTime);
    oscillator.stop(audioContext.currentTime + duration);
  } catch (error) {
    console.log("Sound not supported");
  }
};

export const playCorrectSound = () => {
  playSound(523.25, 2.0); // C5 音符，持續2秒
};

export const playButtonSound = () => {
  playSound(440, 0.05); // A4 音符，較短
};

export const playWrongSound = () => {
  // 播放低沉的錯誤音效，持續2秒
  playSound(220, 2.0, "sawtooth"); // A3 音符，低沉的鋸齒波
};

export const playCompleteSound = () => {
  // 播放一組上升音階
  setTimeout(() => playSound(523.25, 0.15), 0); // C5
  setTimeout(() => playSound(659.25, 0.15), 100); // E5
  setTimeout(() => playSound(783.99, 0.3), 200); // G5
};

// 自動保存間隔
export const AUTO_SAVE_INTERVAL = 30000; // 30秒
